<template>
  <div class="withdraw-card">
    <div
      class="entry-bind-card"
      @click="$router.push({ name: 'settlementSet' })"
      v-if="!bankInfo.bank_card"
    >
      <div class="tip-txt">
        <img src="@/assets/images/icon_bind_caution.png" />
        <span>请尽快绑定银行卡，以免影响提现，已绑定请忽略</span>
      </div>
      <img src="@/assets/images/icon_arrow_orange.png" class="btn-to-bind" />
    </div>
    <!-- <div class="entry-bind-card" @click="openDialog" v-else>
      <div class="tip-txt">
        <img src="@/assets/images/icon_bind_caution.png" />
        <span class="desc">
          新版结算中心于2月28日上线，并自动将原有收益折算为可提现金额，换算前原有各类型收益请点击【收益卡片】
        </span>
        <img src="@/assets/images/icon_arrow_orange.png" class="btn-to-bind" />
      </div>
    </div> -->
    <div class="settlement-card-wrap">
      <div class="card-wrap">
        <div class="title-wrap">
          <span class="title-name">收益提现</span>
          <div class="btn-setup" @click="settleSetClick">
            <span>结算设置</span>
          </div>
        </div>
        <!--提现金额-->
        <div class="wrapdraw-box">
          <div class="title">可提现金额</div>
          <div class="content-wrap">
            <div class="value-wrap">
              <img src="@/assets/images/money_logo.png" class="imgPic" />
              <span class="value">{{ money }} </span>
              <span class="bean">元</span>
            </div>

            <!--判断是否绑定银行卡-->
            <div class="get-wrap" v-if="bankInfo.bank_card">
              <div class="item" v-if="canWithdraw" @click="getMoney">提现</div>
              <div class="disable-item" v-else>提现</div>
            </div>
            <div class="get-wrap" v-else>
              <div
                class="item"
                @click="$router.push({ name: 'settlementSet' })"
              >
                绑定银行卡
              </div>
            </div>
          </div>
          <!-- 紧急添加提示 -->
          <!-- <div class="tips-err">
            <a href="https://dev-wiki.mini1.cn/news/2310">
              开发者您好，由于2023年2月收益数据量较大，导致系统跑数较慢，预估收益于4月5日前到账，抱歉给您带来不便！
            </a>
          </div> -->
        </div>
        <!--提取迷你豆-->
        <div class="wrapdraw-box">
          <div class="title">可提现迷你豆</div>
          <div class="content-wrap">
            <div class="value-wrap">
              <img src="@/assets/images/minibean.png" class="imgPic" />
              <span class="value">{{ minibean }} </span>
              <span class="bean">豆</span>
            </div>
            <div class="get-wrap">
              <div class="item" v-if="minibean > 0" @click="getMinibean">
                提取
              </div>
              <div class="disable-item" v-else>提取</div>
            </div>
          </div>
        </div>
      </div>
      <!--结算说明-->
      <div class="withdraw-desc">
        <div class="title">结算说明</div>
        <div class="item" v-for="(item, index) in descData" :key="index">
          {{ item.content }}
        </div>
        <div class="href">
          查看具体详情：
          <a href="https://dev-wiki.mini1.cn/news/2069" target="_blank">
            《迷你平台结算规则说明》</a
          >
        </div>
      </div>
      <div class="withdraw-record card-wrap">
        <div class="title">
          <div class="name">结算记录</div>
          <div class="more" @click="recordMore">查看更多</div>
        </div>
        <p-datatable
          :value="tableData"
          showGridlines
          stripedRows
          responsiveLayout="scroll"
          :scrollable="true"
          scrollDirection="both"
          class="p-datatable-sm"
        >
          <p-column
            v-for="(item, index) in tableOption"
            :key="index"
            :field="item.prop"
            :header="item.label"
            :frozen="index === 0"
            :styles="{
              'flex-grow': '1',
              'flex-basis': item.with,
            }"
            :bodyClass="item.prop"
          >
            <template #body="slotProps">
              <a
                v-if="item.prop === 'operation'"
                class="operation"
                href="javascript:void(0);"
                @click="gotoDeatil(slotProps.data.id)"
              >
                详情
              </a>
              <span v-else>{{ slotProps.data[item.prop] }}</span>
            </template>
          </p-column>
          <template #empty>
            <NoData></NoData>
          </template>
        </p-datatable>
      </div>
      <!--结算单明细弹框-->
      <div class="income-dialog">
        <van-dialog
          v-model="showDialog"
          title="结算明细"
          :show-confirm-button="false"
        >
          <div class="settlement-wrap">
            <div class="settle-title">2022-01-01日前未结算收益</div>
            <div
              class="content"
              v-for="(item, index) in settleList"
              :key="index"
            >
              <div class="title">{{ item.title }}</div>
              <div class="value">{{ item.value }}元</div>
            </div>
            <div class="sum-wrap">
              <div class="title">合计:</div>
              <div class="value">{{ settleData.sumValue || 0 }}元</div>
            </div>
            <div class="other-wrap">
              <div class="title">迷你豆收入:</div>
              <div class="value">{{ settleData.minibean || 0 }}</div>
            </div>
            <div class="desc-wrap">
              结算明细统计1月1日前，广告、贡献点、迷你点、其他收入中未提现的全部收益，并根据兑换比例进行折算，详细请查看
              <a href="https://dev-wiki.mini1.cn/news/2069" target="_blank">
                《迷你平台结算规则说明》</a
              >
            </div>
            <div class="confirm-button">
              <div class="content" @click="confirm">确定</div>
            </div>
          </div>
        </van-dialog>
      </div>
    </div>
  </div>
</template>

<script>
// import VantTable from '@/components/VantTable';
import { getRecordList } from '@/api/income';
import NoData from '@/components/NoData.vue';
import {
  getSettlementOverview,
  fetchBillDetail,
  fetchIncomeView,
} from '@/api/income';
import { mapState } from 'vuex';
import numeral from 'numeral';
export default {
  computed: {
    ...mapState(['developerInfo']),
    ...mapState(['bankInfo']),
  },
  components: {
    // VantTable,
    'p-datatable': window.datatable,
    'p-column': window.column,
    NoData,
  },
  data() {
    return {
      loading: false,
      currentDate: new Date().getDate(),
      withdrawInfo: {},
      showWithdrawForm: false,
      cardArr: [],
      money: 0,
      money_type: 1,
      minibean: 0,
      money_min: 0,
      minibean_month_max: 0,
      binding: true,
      canWithdraw: true,
      canMinibean: true,
      tableData: [],
      defaultStart:
        new Date(
          new Date(new Date() - 3600 * 1000 * 24 * 30 * 3).toString(),
        ).getTime() / 1000, // 0点时间戳
      defaultEnd:
        new Date(new Date(new Date()).toString()).getTime() / 1000 +
        (24 * 60 * 60 - 1), // 当天23:59:59点时间戳
      tableOption: [
        {
          label: '日期',
          prop: 'create_time',
          with: '100px',
        },
        {
          label: '订单号',
          prop: 'id',
          with: '140px',
        },
        {
          label: '类型',
          prop: 'money_type',
          with: '80px',
        },
        {
          label: '提现数额',
          prop: 'money',
          with: '80px',
        },
        {
          label: '状态',
          prop: 'state',
          with: '80px',
        },
        {
          label: '操作',
          prop: 'operation',
          with: '80px',
        },
      ],
      descData: [
        {
          content:
            '1. 当月的收益数据平台会在N+2月1日确认，并到账个人结算中心的可提现金额及迷你豆之中。',
        },
        {
          content:
            '2. 可提现金额达到100元后可以提取，提取前请先绑定银行卡信息，提现后将在7个工作日内到账。',
        },
        { content: '3. 迷你豆可以提取到游戏之中，目前暂不限制每月额度。' },
        {
          content:
            '4. 个人用户到账金额为平台代扣代征税的税后金额，结算记录中可查看明细',
        },
        {
          content:
            '5. 提现时间为每周一至周五工作时间10:00-18:00，其他时间暂不支持。',
        },
      ],
      showDialog: false,
      tableInfo: {
        page: 1,
        pageSize: 30,
        total: 0,
      },
      settleData: {},
      settleList: [
        {
          title: '广告收入',
          value: 0,
        },
        {
          title: '贡献点收入',
          value: 0,
        },
        {
          title: '迷你点折算收入',
          value: 0,
        },
        {
          title: '奖金收入',
          value: 0,
        },
      ],
      vid: 1,
    };
  },
  filters: {
    regroupMoneyType(type) {
      let moneyTypeTxt = '';
      switch (type) {
        case 1:
          moneyTypeTxt = '贡献点';
          break;
        case 2:
          moneyTypeTxt = '迷你豆';
          break;
        case 3:
          moneyTypeTxt = '广告收入';
          break;
        case 4:
          moneyTypeTxt = '迷你点';
          break;
        case 5:
          moneyTypeTxt = '其他收入';
          break;
        default:
          break;
      }
      return moneyTypeTxt;
    },
    regroupComma(val, type) {
      if (val.toString().includes('.')) {
        let reg = /(\d)(?=(\d{3})+\.)/g;
        let point = '';
        type == 1 ? (point = 3) : (point = 2);
        return val.toFixed(point).toString().replace(reg, '$1,');
      } else {
        let reg = /(\d)(?=(?:\d{3})+$)/g;
        return val.toString().replace(reg, '$1,');
      }
    },
  },
  created() {
    this.getBillDetail();
  },
  mounted() {
    // this.fetchSettlementOverview();
    // this.settleCentrShow();
    this.getInomeView();
    this.fetchRecordList();
  },
  methods: {
    settleSetClick() {
      //结算设置点击埋点
      this.$log('settlement_setting_click', 85434, { v7: 2 });
      this.$router.push({ name: 'settlementSet' });
    },
    //金额提现
    getMoney() {
      this.$router.push({ name: 'withdrawForm', query: { type: 1 } });
    },
    //迷你豆提现
    getMinibean() {
      this.$router.push({ name: 'withdrawForm', query: { type: 2 } });
    },
    openDialog() {
      this.showDialog = true;
    },
    //获取提现记录-默认提现一个月
    async fetchRecordList() {
      try {
        this.loading = true;
        let data = {
          money_type: 999,
          start_time: this.defaultStart,
          end_time: this.defaultEnd,
          page: this.tableInfo.page,
          page_size: this.tableInfo.pageSize,
          dtype: 1,
        };
        const res = await getRecordList(data);
        // this.tableData = res.data.list;
        if (res.data.list.length) {
          this.tableData = res.data.list.map(item => {
            item.money_type = this.regroupMoneyType(item.money_type);
            item.state = this.regroupState(item.state);
            item.create_time = this.regroupDate(item.create_time);
            return item;
          });
        }
        this.tableInfo.total = res.data.total_count;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    regroupDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
    //判断订单状态
    regroupState(val) {
      let stateTxt = '';
      switch (val) {
        case 1:
          stateTxt = '发起提现';
          break;
        case 2:
          stateTxt = '邮寄发票';
          break;
        case 3:
          stateTxt = '签收发票';
          break;
        case 4:
          stateTxt = '发票审核通过';
          break;
        case 5:
          stateTxt = '发票审核失败';
          break;
        case 6:
          stateTxt = '打款成功';
          break;
        case 7:
          stateTxt = '订单关闭';
          break;
        case 8:
          stateTxt = '打款完成';
          break;
        default:
          break;
      }
      return stateTxt;
    },
    regroupMoneyType(val) {
      let moneyTypeTxt = '';
      switch (val) {
        case 1:
          moneyTypeTxt = '现金';
          break;
        case 2:
          moneyTypeTxt = '迷你豆';
          break;
        default:
          break;
      }
      return moneyTypeTxt;
    },
    //获取个人提现信息
    async getInomeView() {
      try {
        const res = await fetchIncomeView({ dtype: 1 });
        this.money = res.data.money;
        this.money_min = res.data.money_min;
        this.minibean = res.data.minibean;
        this.minibean_month_max = res.data.minibean_month_max;
        if (this.money > this.money_min || this.money === this.money_min) {
          this.canWithdraw = true;
        } else {
          this.canWithdraw = false;
        }
        if (
          this.minibean > this.minibean_month_max ||
          this.minibean === this.minibean_month_max
        ) {
          this.canMinibean = true;
        } else {
          this.canMinibean = false;
        }
      } catch (error) {
        console.error();
      }
    },
    confirm() {
      this.showDialog = false;
    },
    recordMore() {
      this.$router.push({ name: 'settlementDetail' });
    },
    //获取结算明细
    async getBillDetail() {
      const res = await fetchBillDetail();
      try {
        this.settleData = res.data;
        this.settleData.sumValue = numeral(
          res.data.ad +
            res.data.contribution +
            res.data.minipoint +
            res.data.other,
        ).format('0,0');
        this.settleData.minibean = numeral(this.settleData.minibean).format(
          '0,0',
        );
        this.settleList = [
          {
            title: '广告收入',
            value: numeral(this.settleData.ad).format('0,0'),
          },
          {
            title: '贡献点收入',
            value: numeral(this.settleData.contribution).format('0,0'),
          },
          {
            title: '迷你点折算收入',
            value: numeral(this.settleData.minipoint).format('0,0'),
          },
          {
            title: '奖金收入',
            value: numeral(this.settleData.other).format('0,0'),
          },
        ];
      } catch (e) {
        console.log(e);
      }
    },
    gotoDeatil(id) {
      this.$router.push({
        name: 'withdrawDetail',
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.entry-bind-card {
  font-size: 24px;
  position: absolute;
  top: 80px;
  left: 0;
  color: #fd9b21ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  // height: 65px;
  background: #fffaed;
  padding: 14px 32px;
  padding-right: 25px;
  align-items: center;
  .tip-txt {
    display: flex;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
  .btn-to-bind {
    width: 32px !important;
    height: 32px !important;
  }
}
.settlement-card-wrap {
  //   margin-top: 96px;
  font-size: 24px;
  // position: relative;
  color: #262626;
  .card-wrap {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    .title-wrap {
      padding: 14px 8px 14px 21px;
    }
  }
  .title-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    color: #000000;
    .title-name {
      font-size: 34px;
      font-weight: 500;
    }
    .btn-setup {
      font-size: 28px;
    }
  }
  .wrapdraw-box {
    width: 676px;
    // height: 177px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.02);
    margin-left: 0;
    margin-bottom: 20px;
    border-radius: 8px;
    display: block;
    padding: 20px;
    .tips-err {
      a {
        text-decoration: none;
        color: red;
        font-size: 20px;
      }
    }
    &:last-child {
      margin-bottom: 8px;
    }
    .title {
      margin: 0 auto;
      font-size: 28px;
      color: #8c8c8c;
    }
    .content-wrap {
      display: flex;
      // margin-left: 16px;
      .value-wrap {
        display: flex;
        flex: 1;
        align-items: center;
        img {
          width: 56px;
          height: 56px;
          margin-right: 20px;
        }
        .value {
          font-size: 64px;
          font-weight: 500;
          color: #000000;
        }
        .bean {
          font-size: 36px;
          margin-bottom: -13px;
          margin-left: 3px;
        }
      }
      .get-wrap {
        margin-right: 32px;
        margin-top: 10px;
        .item {
          min-width: 160px;
          height: 68px;
          padding: 0px 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #fffaed;
          border-radius: 8px;
          color: #fd9b21;
          font-size: 32px;
          border: 2px solid #ffc973;
        }
        .disable-item {
          min-width: 160px;
          padding: 0px 20px;
          height: 68px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #d9d9d9;
          border-radius: 8px;
          color: #fffaed;
          font-size: 32px;
        }
      }
    }
  }
  .withdraw-desc {
    margin-top: 32px;
    .title {
      color: #000000;
      font-size: 34px;
    }
    .item {
      color: #8c8c8c;
      font-size: 24px;
      // margin-bottom: 10px;
      line-height: 54px;
    }
    .href {
      color: #000000;
      font-size: 24px;
      a {
        color: #2b6ddfff;
      }
    }
  }
  .withdraw-record {
    margin-top: 36px;
    .title {
      color: #000000;
      display: flex;
      font-size: 32px;
      align-items: center;
      line-height: 45px;
      padding: 14px 8px;
      margin-bottom: 23px;
      .name {
        flex: 1;
      }
      .more {
        font-size: 28px;
        color: #2b6ddfff;
      }
    }
    // .table-wrap {
    //   .vant-table {
    //     .head-tr {
    //       height: 56px;
    //     }
    //   }
    // }
  }
}
.img-loading {
  position: absolute;
  top: 40%;
  left: 50%;
}
.income-dialog {
  /deep/.van-dialog {
    width: 686px;
    // height: 908px;
    background: #ffffff;
    border-radius: 16px;
  }
  /deep/.van-dialog__header {
    padding-top: 32px;
    padding-bottom: 42px;
    font-weight: 500;
    color: #262626;
    font-size: 36px;
  }
  /deep/.van-dialog__content {
    padding: 0px 40px;
  }
  .settlement-wrap {
    .settle-title {
      font-size: 32px;
      color: #262626;
      margin-bottom: 42px;
    }
    .content {
      display: flex;
      color: #595959;
      font-size: 32px;
      margin-bottom: 37px;
      .title {
        flex: 1;
      }
    }
    .sum-wrap {
      display: flex;
      margin-top: 8px;
      color: #000000;
      font-size: 32px;
      .title {
        flex: 1;
      }
    }
    .other-wrap {
      display: flex;
      color: #000000;
      font-size: 34px;
      margin-top: 22px;
      .title {
        flex: 1;
      }
    }
    .desc-wrap {
      color: #8c8c8c;
      font-size: 24px;
      margin: 40px 0px 43px 0px;
      a {
        color: #2b6ddf;
      }
    }
    .confirm-button {
      width: 100%;
      display: flex;
      justify-content: center;
      .content {
        width: 360px;
        height: 90px;
        background: #fd9b21;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 32px;
        margin-bottom: 54px;
      }
    }
  }
}
.operation {
  color: #2b6ddf;
}
</style>
